module.exports = __webpack_public_path__ + "assets/tiaoxin.03725366.svg";